// extracted by mini-css-extract-plugin
module.exports = {"container":"CommonImage_container__Ff2xs"};